module.exports = __webpack_public_path__ + "static/media/step2N.de84fcf6.svg";